<template>
<div class="video-slider">
  <div
    v-if="removePlayButton === false"
    class="video-play-button animation"
    :style="`background-image: url('${require('@/assets/videoPlaceholder.jpg')}');`"
    :class="{
      'video-play-button-hide': showPlayButton === false
    }"
    @click="play()"
    >
    <div class="center-video animation">
      <svg width="129px" height="129px" viewBox="0 0 129 129" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Group">
                  <circle id="Oval" fill="#52C0A5" cx="64.5" cy="64.5" r="64.5"></circle>
                  <path d="M52.0366043,38.8403683 L92.3262397,63.2583561 C93.2708649,63.8308569 93.5725313,65.0607304 93.0000306,66.0053556 C92.8273931,66.2902071 92.5863466,66.5274316 92.2987723,66.6954947 L52.0091369,90.2414116 C51.0554828,90.7987425 49.8305875,90.4774591 49.2732566,89.523805 C49.0943078,89.2176041 49,88.8693253 49,88.5146682 L49,40.5507634 C49,39.4461939 49.8954305,38.5507634 51,38.5507634 C51.3655064,38.5507634 51.7240241,38.6509255 52.0366043,38.8403683 Z" id="Rectangle" fill="#ffffff"></path>
              </g>
          </g>
      </svg>
    </div>
  </div>
  <div class="video-wrapper">
    <vimeo-player
      v-if="width > 0"
      :video-id="videoId"
      ref="videoPlayer"
      @ended="ended"
      @pause="paused"
      @play="playing"
      :player-width="width"
      :player-height="height"
      />

    <!-- <youtube
      video-id="OeqpjVPco-0"
      :player-vars="playerVars"
      :fitParent="true"
      :resize="true"
      ref="videoPlayer"
      @ended="ended"
      @paused="paused"
      @playing="playing"
      /> -->
  </div>
</div>
</template>
<script>

import logScope from 'log-scope'
const log = logScope('VideoSlide')

export default {
  data () {
    return {
      showPlayButton: true,
      removePlayButton: false,
      playerVars: {},
      height: 0,
      width: 0,
      videoId: '358733076',
      videoIdSwe: '358733076',
      videoIdEng: '364459808'
    }
  },
  mounted () {
    this.$nextTick(() => {
      const { height, width } = this.$el.getBoundingClientRect()

      if (height > 0 && width > 0) {
        this.width = width
        this.height = height
      }

      log.debug('Size', { height, width })

      if (window.k$.lang === 'eng') {
        this.videoId = this.videoIdEng
      }
    })
  },
  methods: {
    ended () {
      this.$store.commit('videoIsPlaying', false)
      this.removePlayButton = false
      this.showPlayButton = true
    },
    paused () {
      this.$store.commit('videoIsPlaying', false)
    },
    playing () {
      this.$store.commit('videoIsPlaying', true)
    },
    play () {
      this.showPlayButton = false

      this.$nextTick(() => {
        this.$refs.videoPlayer.play()
        this.playing()

        setTimeout(() => {
          this.removePlayButton = true
        }, 400)
      })
    }
  }
}
</script>
<style lang="less" scoped>
  @import "~style/variables.less";

  .video-slider {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: auto;
    width: 100%;
    padding: 0px 0px;
    box-shadow: @shadow;
    height: auto;
    min-height: 50vw;
    max-height: 400px;
  }

  .video-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 100%;
    padding: 0px;
    height: auto;
    z-index: 1;
    opacity: 1;
    background-color: #fff;
    margin: 20px 0px;
  }

  .video-play-button {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    height: 100%;
    width: 100%;
    background-color: #ffffff;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 2;
    opacity: 1;
    cursor: pointer;

    img {
      cursor: pointer;
    }
  }

  .video-play-button-hide {
    opacity: 0;
  }

  .center-video:hover {
    cursor: pointer;
    transform: scale(1.1);
  }
</style>
